import { useState } from "react";
import "./Tooltip.css";
/**
 *
 * @param props
 * Code by: https://paladini.dev/posts/how-to-make-an-extremely-reusable-tooltip-component-with-react--and-nothing-else/
 */
export default function Tooltip({
  children,
  delay,
  direction,
  content,
  icon,
  style,
}) {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(
      () => {
        setActive(true);
      },
      delay != null ? delay : 100
    );
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      style={style}
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      <i className={`fas ${icon || "fa-question-circle"}`}></i>
      {active && (
        <div className={`Tooltip-Tip ${direction != null ? direction : "top"}`}>
          {/* Content */}
          {content}
        </div>
      )}
    </div>
  );
}
